<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:90px !important;">
    </div>
    <div class="box">
      <article class="media">
        <!-- <div class="media-left">
          <figure class="image is-64x64">
            <img src="https://bulma.io/images/placeholders/128x128.png" alt="Image">
          </figure>
        </div> -->
        <div class="media-content">
          <div class="content" v-if="data">
            <h3 v-if="action === 'claim'">แจ้งเคลมประกัน</h3>
            <h3 v-else>แจ้งต่อประกัน</h3>
            <p>
              <strong>รถรุ่น {{data.Model}} ทะเบียน {{data.licenseNo}}</strong><br>
              <small>หมายเลขเครื่อง {{data.frameNo}}</small>
              <br><br>
              <b>{{data.Insurrance}}</b><br>
              <b>เบอร์โทร: </b> {{insurance[0].tel}}<br>
              <b>เลขกรมธรรม์:</b> {{data.NoticeNo}}<br>
              <b>ประเภทประกัน:</b> ชั้น {{data.insuranceType}}<br>
              <b>เริ่มต้น:</b> {{data.startDate}}<br>
              <b>สิ้นสุด:</b> {{data.endDate}}<br>
            </p>
          </div>
          <nav class="level is-mobile" v-if="action === 'claim'">
            <div class="level-left">
              <a :href="'tel://'+insurance[0].tel" class="button is-link">โทรเพื่อเคลมประกัน</a>
            </div>
          </nav>
          <nav class="level is-mobile" v-if="action === 'renew'">
            <div class="level-left error">
              ส่งคำร้องขอต่อประกันให้เจ้าหน้าที่เรียบร้อยแล้ว<br>
              เจ้าหน้าที่จะติดต่อกลับไป ขอบคุณค่ะ
            </div>
          </nav>
        </div>
      </article>
    </div>
  </div>
</template>
<style scoped>
.error {
  color: red;
}
.banner {
  background-color: #000;
}
</style>
<script>
export default {
  name: 'Insurance',
  beforeCreate () {
  },
  components: {
  },
  data: () => ({
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    data: null,
    id: null,
    action: null,
    insurance: [{tel: ''}]
  }),
  async mounted () {
    await this.$liff.init({ liffId: this.$liffId_Insurance }, function (data) {})
    this.branch = this.$branchList
    await this.checkLiffLogin()
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    const params = new URLSearchParams(queryString)
    this.id = params.get('id')
    this.action = params.get('action')
    this.getData()
  },
  methods: {
    async checkLiffLogin () {
      await this.$liff.ready.then(async () => {
        if (process.env.NODE_ENV === 'development') {
          this.getProfile_dev()
        } else {
          if (!this.$liff.isLoggedIn()) {
            this.$liff.login({redirectUri: window.location})
          } else {
            await this.getProfile()
          }
        }
      })
    },
    async getData () {
      await this.$axios
        .get(`${this.$apiUrl}getInsuranceInfo?id=${this.id}`)
        .then(response => {
          this.data = response.data
          this.insurance = this.$insuranceList.filter((temp) => { return temp.name === this.data['Insurrance'] })
          this.data['insuranceTel'] = this.insurance[0].tel
          this.data['branchName'] = this.$branchList.filter((temp) => {
            return parseInt(temp.id) === parseInt(this.data['branch'])
          })
          this.data['branchName'] = this.data['branchName'][0].name
          if (this.action === 'claim') {
            this.sendClaim()
          } else {
            this.sendRenew()
          }
        })
    },
    async sendClaim () {
      let params = {
        data: this.data
      }
      await this.$axios
        .post(`${this.$apiUrl}sendClaim`, params)
        .then(response => {
          console.log(response)
        })
    },
    async sendRenew () {
      let params = {
        data: this.data
      }
      await this.$axios
        .post(`${this.$apiUrl}sendRenew`, params)
        .then(response => {
          console.log(response)
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurance.vue